import React from 'react';
import { makeStyles } from '@mui/styles';

import AlertIcon from '@mui/icons-material/ErrorRounded';
import SuccessIcon from '@mui/icons-material/CheckCircleRounded';

import CommonStyles from './CommonStyles';

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    padding: '8px 2px',
    alignItems: 'center',
  },
  icon: {
    color: '#fff',
    marginRight: 10,
  },
  text: {
    color: '#fff',
    fontSize: 12,
    marginRight: 10,
    fontWeight: 500,
    letterSpacing: '0.05em',
    wordBreak: 'break-word',
  },
  ...CommonStyles,
});

export default (props) => {
  const classes = useStyles({
    props,
  });

  return (
    <div className={classes.mainContainer}>
      {props.status === 'error' ? (
        <AlertIcon className={classes.icon} />
      ) : props.status === 'success' ? (
        <SuccessIcon className={classes.icon} />
      ) : props.status === 'info' ? (
        <AlertIcon className={classes.icon} />
      ) : null}

      <div className={classes.text}>{props.text}</div>
    </div>
  );
};
